/**
 * «Add to calendar» after a booking made on the client's own phone (owner 26.10.2026).
 * An .ics file: iPhone Safari offers «Add to Calendar», Android opens the calendar app.
 * Nothing leaves the phone; no calendar account is connected.
 */
export interface CalendarEvent {
  id: string;
  /** ISO start with offset, e.g. 2026-11-03T12:45:00+00:00 */
  start: string;
  minutes: number;
  title: string;
  location?: string;
  /** Google Maps link to the studio (owner 26.10.2026: the client must know where to go). */
  url?: string;
  description?: string;
}

function utc(d: Date): string {
  return d
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}/, '');
}

function esc(text: string): string {
  return text.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
}

export function icsText(e: CalendarEvent, now = new Date()): string {
  const start = new Date(e.start);
  const end = new Date(start.getTime() + e.minutes * 60_000);
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//360FACE//Hub//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${e.id}@360face.pt`,
    `DTSTAMP:${utc(now)}`,
    `DTSTART:${utc(start)}`,
    `DTEND:${utc(end)}`,
    `SUMMARY:${esc(e.title)}`,
    ...(e.location ? [`LOCATION:${esc(e.location)}`] : []),
    ...(e.url ? [`URL:${e.url}`] : []),
    ...(e.description ? [`DESCRIPTION:${esc(e.description)}`] : []),
    'BEGIN:VALARM',
    'ACTION:DISPLAY',
    `DESCRIPTION:${esc(e.title)}`,
    'TRIGGER:-PT2H',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ];
  return lines.join('\r\n') + '\r\n';
}

export function icsHref(e: CalendarEvent): string {
  return `data:text/calendar;charset=utf-8,${encodeURIComponent(icsText(e))}`;
}

/** Google Maps search for the studio, e.g. «360°FACE Rua Azedo Gneco 48B, 1350-036 Lisboa». */
export function mapsUrl(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`360°FACE ${address}`)}`;
}
